// Angular
import { Routes } from '@angular/router';

// App
import { isAuthenticatedGuard } from './@shared/authentication/auth-guard.service';
import { MainLayoutComponent } from '@shared-layouts';
import { roleGuard } from '@shared-guards';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./uplift/features/login/login.routes').then((m) => m.loginRoutes),
  },
  {
    path: 'password-reset/:token',
    loadChildren: () =>
      import('./@pages/password/password.routes').then((m) => m.PasswordRoutes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isAuthenticatedGuard],
    canActivateChild: [roleGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./@pages/home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: 'provider',
        loadChildren: () =>
          import('./@pages/provider/provider.routes').then(
            (m) => m.providerRoutes,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./@pages/reports/reports.routes').then(
            (m) => m.ReportsRoutes,
          ),
      },
      {
        path: 'details_portfolio',
        loadChildren: () =>
          import('./uplift/features/commercial/pages/portfolio/reports/portfolio-report.routes').then(
            (m) => m.portfolioReportRoutes,
          ),
      },
      {
        path: 'details_purchase/:id_invoice/:company/:type',
        loadChildren: () =>
          import('./@pages/details-purchases/details-purchases.routes').then(
            (m) => m.DetailsPurchasesRoutes,
          ),
      },
      {
        path: 'selectDB',
        loadChildren: () =>
          import('./@pages/selectDB/selectDB.routes').then(
            (m) => m.SelectDBRoutes,
          ),
      },
      {
        path: 'sales',
        redirectTo: 'commercial/sales',
        pathMatch: 'full',
      },
      {
        path: 'purchases',
        loadChildren: () =>
          import('./@pages/purchases/purchases.routes').then(
            (m) => m.PurchasesRoutes,
          ),
      },

      {
        path: 'details/:id_factura/:company/:type',
        loadChildren: () =>
          import('./@pages/details/details.routes').then(
            (m) => m.DetailsRoutes,
          ),
      },
      {
        path: 'customer',
        redirectTo: 'commercial/customers',
        pathMatch: 'full',
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('./@pages/inventory/inventory.routes').then(
            (m) => m.InventoryRoutes,
          ),
      },
      {
        path: 'inventory_movements',
        loadChildren: () =>
          import('./@pages/inventory-movements/inventory-movements.routes').then(
            (m) => m.InventoryMovementsRoutes,
          ),
      },
      {
        path: 'sellers',
        loadChildren: () =>
          import('./@pages/sellers/sellers.routes').then(
            (m) => m.SellersRoutes,
          ),
      },
      {
        path: 'portfolio',
        redirectTo: 'commercial/portfolio',
        pathMatch: 'full',
      },
      {
        path: 'analysis',
        loadChildren: () =>
          import('./@pages/analysis/analysis.routes').then(
            (m) => m.AnalysisRoutes,
          ),
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./@pages/warehouse/warehouse.routes').then(
            (m) => m.WarehouseRoutes,
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./@pages/users/users.routes').then((m) => m.UsersRoutes),
      },
      {
        path: 'profile/:token',
        loadChildren: () =>
          import('./@pages/profile/profile.routes').then(
            (m) => m.ProfileRoutes,
          ),
      },
      {
        path: 'details_notas/:noteId/:company',
        loadChildren: () =>
          import('./uplift/features/notes/components/note-pdf/note-pdf.routes').then(
            (m) => m.notePdfRoutes,
          ),
      },
      {
        path: 'details_refunds/:id_invoice/:id_refund',
        loadChildren: () =>
          import('./@pages/details-refunds/details-refunds.routes').then(
            (m) => m.DetailsRefundsRoutes,
          ),
      },
      {
        path: 'tributary',
        loadChildren: () =>
          import('./@pages/tributary/tributary.routes').then(
            (m) => m.TributaryRoutes,
          ),
      },
      {
        path: 'accountsPayable',
        loadChildren: () =>
          import('./uplift/features/commercial/pages/accounts-payable/accounts-payable.routes').then(
            (m) => m.accountsPayableRoutes,
          ),
      },
      {
        path: 'details_accounts_payable',
        loadChildren: () =>
          import('./uplift/features/commercial/pages/accounts-payable/reports/accounts-payable-report.routes').then(
            (m) => m.accountsPayableReportRoutes,
          ),
      },
      {
        path: 'imports',
        loadChildren: () =>
          import('./@pages/import-files/import-files.routes').then(
            (m) => m.ImportFilesRoutes,
          ),
      },
      {
        path: 'treasury',
        loadChildren: () =>
          import('./uplift/features/treasury/treasury.routes').then(
            (m) => m.TREASURY_ROUTES,
          ),
      },
      // Example of a migrated route created in the uplift folder
      {
        path: 'example-view',
        loadChildren: () =>
          import('./uplift/features/example-view/example-view.routes').then(
            (m) => m.EXAMPLE_VIEW_ROUTES,
          ),
      },
      {
        path: 'commercial',
        loadChildren: () =>
          import('./uplift/features/commercial/commercial.routes').then(
            (m) => m.COMMERCIAL_ROUTES,
          ),
      },
      {
        path: 'inventory-jobs',
        loadChildren: () =>
          import('./uplift/features/inventory-jobs/inventory-jobs.routes').then(
            (m) => m.INVENTORY_JOBS_ROUTES,
          ),
      },
      // Dummy hops used by AlertsService.refresh() and equivalent
      // navigate-away-then-back tricks (see purchase-card, table.service,
      // modify-lists-dialog, profile, etc.) to force a component reload.
      // Without a real route match here they fell through to the wildcard
      // below and landed on commercial/sales instead of resolving instantly.
      {
        path: 'card',
        loadComponent: () =>
          import('./uplift/shared/components/blank-route/blank-route.component').then(
            (m) => m.BlankRouteComponent,
          ),
      },
      {
        path: 'table',
        loadComponent: () =>
          import('./uplift/shared/components/blank-route/blank-route.component').then(
            (m) => m.BlankRouteComponent,
          ),
      },
      {
        path: 'dialog',
        loadComponent: () =>
          import('./uplift/shared/components/blank-route/blank-route.component').then(
            (m) => m.BlankRouteComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./uplift/shared/components/blank-route/blank-route.component').then(
            (m) => m.BlankRouteComponent,
          ),
      },
      { path: '', redirectTo: 'commercial/sales', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
